/* unplugin-vue-components disabled */import { render } from "./restricted.vue?vue&type=template&id=64c4952b&scoped=true"
const script = {}

import "./restricted.vue?vue&type=style&index=0&id=64c4952b&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c4952b"],['__file',"src/components/ai-chat/ai-file/restricted.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64c4952b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64c4952b', __exports__)) {
    api.reload('64c4952b', __exports__)
  }
  
  module.hot.accept("./restricted.vue?vue&type=template&id=64c4952b&scoped=true", () => {
    api.rerender('64c4952b', render)
  })

}


export default __exports__